import { Pipe, PipeTransform } from '@angular/core';

/** Replaces legally strong compliance terms (e.g. "Non-Compliant") with softer display labels to reduce liability, while the original rubrics remain available to the LLM. */
@Pipe({
  name: 'complianceRiskLabel',
  standalone: true,
})
export class ComplianceRiskLabelPipe implements PipeTransform {
  transform(status: string | undefined | null): string {
    if (!status) return '-';
    switch (status) {
      case 'Compliant':
        return 'Low Risk';
      case 'Non-Compliant':
        return 'High Risk';
      case 'Partially Compliant':
        return 'Medium Risk';
      default:
        return status;
    }
  }
}
